import React from 'react';
import { TableCell, TableHead, TableRow } from '@material-ui/core';
import { ArrowDownward, ArrowUpward } from '@material-ui/icons';
import { ColumnDef, SortConfig } from './types';

const HEADER_STYLE: React.CSSProperties = {
    padding: '8px 12px',
    borderRight: '1px solid #e0e0e0',
    borderBottom: '2px solid #e0e0e0',
    boxSizing: 'border-box',
    fontWeight: 700,
    backgroundColor: '#fafafa',
    display: 'flex',
    alignItems: 'center',
    gap: 4,
};

export interface DataTableHeaderProps<T> {
    columns: ColumnDef<T>[];
    sortConfig?: SortConfig | null;
    onSort?: (field: string) => void;
}

function DataTableHeader<T>({ columns, sortConfig, onSort }: DataTableHeaderProps<T>) {
    return (
        <TableHead component="div" style={{ display: 'contents' }}>
            <TableRow
                component="div"
                style={{
                    display: 'flex',
                    width: '100%',
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    margin: 0,
                    padding: 0,
                }}
            >
                {columns.map((col) => {
                    const isSortable = !!col.sortable;
                    const isActiveSort = sortConfig?.field === col.id;
                    const SortIcon = isActiveSort && sortConfig?.direction === 'desc' ? ArrowDownward : ArrowUpward;
                    const flex = col.flex ?? 1;
                    return (
                        <TableCell
                            key={col.id}
                            component="div"
                            padding="none"
                            style={{
                                ...HEADER_STYLE,
                                flex: flex === 0 ? `0 0 ${col.width}px` : `${flex} 1 ${col.width}px`,
                                width: col.width,
                                minWidth: col.minWidth ?? col.width,
                                justifyContent:
                                    col.align === 'right' ? 'flex-end' : col.align === 'center' ? 'center' : 'flex-start',
                                cursor: isSortable && onSort ? 'pointer' : 'default',
                            }}
                            onClick={isSortable ? () => onSort?.(col.id) : undefined}
                        >
                            <span>{col.header}</span>
                            {isSortable && isActiveSort && <SortIcon style={{ fontSize: 16, flexShrink: 0 }} />}
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableHead>
    );
}

export default React.memo(DataTableHeader) as typeof DataTableHeader;
